DeepModel = require 'models/base/deep_model'

module.exports = class User extends DeepModel
  defaults:
    stateUnknown: true
    isAuthenticated: false